<template>
  <b-row>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template #header>
            <h5 class="m-0">Ouvidoria</h5>
          </template>
          <b-card-body>
            <filters-bar
              :filter.sync="filter"
              :ombudsman-status="OmbudsmanStatus"
              :profile="profile"
              :has-advanced-search="hasAdvancedSearch"
              @apply="applyFilter"
            />

            <div class="table-container">
              <ombudsman-table
                :items="data.docs"
                :headers="headers"
                :loading="loading"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                :search-term="filter.text"
                @row-clicked="edit"
                @sort-changed="onSortChanged"
              />
            </div>

            <nav class="pagination-nav">
              <b-pagination
                v-model="data.page"
                :total-rows="data.total"
                :per-page="data.limit"
                prev-text="Anterior"
                next-text="Próximo"
                align="center"
              />
            </nav>
          </b-card-body>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import { getOmbudsmanList } from "@/api/ombudsman";
import { mapGetters } from "vuex";
import OmbudsmanStatus from "../../../../backend/models/ombudsman/OmbudsmanStatus.ts";
import FiltersBar from "./OmbudsmanList/FiltersBar.vue";
import OmbudsmanTable from "./OmbudsmanList/OmbudsmanTable.vue";

export default {
  name: "OmbudsmanList",
  components: { FiltersBar, OmbudsmanTable },
  data() {
    return {
      OmbudsmanStatus,
      sortBy: "createdAt",
      sortDesc: true,
      loading: false,
      filter: {
        text: "",
        status: null,
      },
      data: {
        docs: [],
        total: 0,
        page: 1,
        pages: 0,
        limit: 15,
      },
    };
  },
  computed: {
    ...mapGetters(["profile"]),
    hasAdvancedSearch() {
      return true;
    },
    headers() {
      const headers = [{ key: "id", label: "Nº Seq.", sortable: true }];
      if (
        this.profile.role === "root" ||
        (this.profile.managedCompanies && this.profile.managedCompanies.length)
      ) {
        headers.push({
          key: "company",
          label: "Empresa",
          thStyle: { "min-width": "200px !important" },
          sortable: true,
        });
      }
      headers.push(
        { key: "protocol", label: "Protocolo", sortable: true },
        { key: "person", label: "Requerente", sortable: true },
        {
          key: "createdAt",
          label: "Data de Recebimento",
          thStyle: { width: "180px !important" },
          sortable: true,
        },
        {
          key: "updatedAt",
          label: "Última Movimentação",
          thStyle: { width: "180px !important" },
          sortable: true,
        },
        {
          key: "deadline",
          label: "Prazo",
          thStyle: { width: "180px !important" },
          sortable: true,
        }
      );

      if (this.filter.text && this.filter.text.trim()) {
        headers.push({
          key: "snippet",
          label: "Trecho do Relato",
          sortable: false,
        });
      }

      headers.push({ key: "status", label: "Status", sortable: true });

      return headers;
    },
  },
  watch: {
    "data.page": "fetchOmbudsman",
  },
  async mounted() {
    this.fetchOmbudsman();
  },
  methods: {
    applyFilter() {
      this.data.page = 1;
      this.fetchOmbudsman();
    },

    edit(item) {
      const ombudsmanLink = this.ombudsmanLink(item._id);
      this.$router.push({ path: ombudsmanLink });
    },

    ombudsmanLink(id) {
      return `ouvidoria/${id.toString()}`;
    },

    onSortChanged(sortOptions) {
      if (sortOptions.sortBy) {
        this.sortBy = sortOptions.sortBy;
        this.sortDesc = sortOptions.sortDesc || false;
      } else {
        this.sortBy = null;
        this.sortDesc = false;
      }
      this.fetchOmbudsman();
    },

    async fetchOmbudsman() {
      this.loading = true;
      try {
        const query = {
          page: this.data.page,
          size: this.data.limit,
          sortBy: this.sortBy,
          sortDesc: this.sortDesc,
          filter: {
            text:
              this.filter.text && this.filter.text.trim()
                ? this.filter.text.trim()
                : undefined,
            status:
              this.filter.status !== null &&
              this.filter.status !== undefined &&
              this.filter.status !== ""
                ? this.filter.status
                : undefined,
          },
        };

        const response = await getOmbudsmanList(query);
        const responseData = response.data;
        this.data = responseData;
      } catch (error) {
        console.error("Erro ao carregar ouvidoria:", error);
        let errorMessage = "Erro ao carregar ouvidoria";
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        this.$bvToast.toast(errorMessage, {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        this.data.docs = [];
        this.data.total = 0;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  overflow: hidden;
}

.pagination-nav {
  margin-top: 1.5rem;
}

::v-deep .page-item .page-link {
  border-radius: 6px;
  margin: 0 3px;
  border: 1px solid #e9ecef;
  color: #495057;
  transition: background-color 0.2s, color 0.2s;
}

::v-deep .page-item .page-link:hover {
  background-color: #f0f2f5;
  color: #0056b3;
}

::v-deep .page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
}

::v-deep .page-item.disabled .page-link {
  background-color: transparent;
  color: #adb5bd;
}
</style>
